import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function Services() {
  const services = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'Retail Service',
      description: 'We provide high-quality sanitary and hardware products for individual customers at competitive prices. Visit our store for personalized service and expert guidance.',
      features: [
        'Wide range of products',
        'Competitive pricing',
        'Quality assurance',
        'Expert consultation'
      ],
      image: 'https://public.readdy.ai/ai/img_res/9b0a5fd492ab73391b46cb49a15c38de.jpg'
    },
    {
      icon: 'ri-store-3-line',
      title: 'Wholesale Service',
      description: 'Special wholesale rates for contractors, builders, and businesses. We offer bulk orders with attractive discounts and reliable supply for your projects.',
      features: [
        'Bulk order discounts',
        'Reliable supply chain',
        'Flexible payment terms',
        'Priority service'
      ],
      image: 'https://readdy.ai/api/search-image?query=warehouse%20with%20stacked%20sanitary%20products%20and%20plumbing%20supplies%2C%20wholesale%20distribution%20center%2C%20organized%20inventory%2C%20professional%20business%20environment%2C%20bulk%20storage%20of%20pipes%20and%20fittings&width=600&height=400&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Plumbing Services',
      description: 'Professional plumbing services for residential and commercial projects. Our experienced plumbers handle installation, repair, and maintenance work with expertise.',
      features: [
        'Experienced plumbers',
        'Installation services',
        'Repair and maintenance',
        'Emergency support'
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20plumber%20installing%20bathroom%20fixtures%20and%20pipes%2C%20skilled%20worker%20in%20uniform%20working%20on%20plumbing%20installation%2C%20modern%20bathroom%20renovation%2C%20professional%20plumbing%20service%2C%20tools%20and%20equipment%20visible&width=600&height=400&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Expert Plumber Provision',
      description: 'Need a skilled plumber for your project? We provide trained and experienced plumbers for all types of plumbing work, from simple repairs to complete installations.',
      features: [
        'Skilled professionals',
        'Timely service',
        'Quality workmanship',
        'Affordable rates'
      ],
      image: 'https://readdy.ai/api/search-image?query=team%20of%20professional%20plumbers%20with%20tools%20and%20equipment%2C%20skilled%20workers%20in%20work%20uniforms%2C%20plumbing%20service%20team%2C%20professional%20contractors%20ready%20for%20work%2C%20modern%20plumbing%20professionals&width=600&height=400&seq=service4&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Product Guidance',
      description: 'Not sure which product is right for you? Our knowledgeable staff provides expert consultation to help you choose the best products for your specific needs and budget.',
      features: [
        'Expert advice',
        'Product comparison',
        'Budget planning',
        'Technical support'
      ],
      image: 'https://readdy.ai/api/search-image?query=sales%20consultant%20helping%20customer%20choose%20bathroom%20fixtures%20in%20showroom%2C%20professional%20customer%20service%2C%20product%20demonstration%2C%20friendly%20staff%20assisting%20with%20product%20selection%2C%20modern%20retail%20environment&width=600&height=400&seq=service5&orientation=landscape'
    },
    {
      icon: 'ri-truck-line',
      title: 'Delivery Service',
      description: 'Fast and reliable delivery service across Rawalpindi and Islamabad. We ensure your products reach you safely and on time, with careful handling and packaging.',
      features: [
        'Fast delivery',
        'Safe packaging',
        'Wide coverage area',
        'Tracking available'
      ],
      image: 'https://readdy.ai/api/search-image?query=delivery%20truck%20loaded%20with%20sanitary%20products%20and%20plumbing%20supplies%2C%20professional%20delivery%20service%2C%20workers%20loading%20packages%20carefully%2C%20modern%20logistics%2C%20safe%20transportation%20of%20goods&width=600&height=400&seq=service6&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-500 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Our Services</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Comprehensive solutions for all your sanitary, plumbing, and hardware needs
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div 
                key={index}
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
              >
                <div className="lg:w-1/2">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-96 object-cover rounded-2xl shadow-xl"
                  />
                </div>
                <div className="lg:w-1/2">
                  <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mb-6">
                    <i className={`${service.icon} text-3xl text-orange-600`}></i>
                  </div>
                  <h2 className="text-3xl font-bold mb-4 text-gray-800">{service.title}</h2>
                  <p className="text-gray-600 text-lg mb-6 leading-relaxed">{service.description}</p>
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <h3 className="font-bold text-gray-800 mb-4 text-lg">What We Offer:</h3>
                    <ul className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center gap-3 text-gray-700">
                          <i className="ri-check-double-line text-orange-600 text-xl"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">Why Choose Malik Brothers</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-time-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Years of Experience</h3>
              <p className="text-gray-600">Trusted name in Rawalpindi with extensive industry experience</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Quality Guaranteed</h3>
              <p className="text-gray-600">Only premium quality products from trusted brands</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-team-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Expert Team</h3>
              <p className="text-gray-600">Knowledgeable staff and skilled plumbers at your service</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-6">
                <i className="ri-customer-service-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">Customer Support</h3>
              <p className="text-gray-600">Dedicated support before, during, and after purchase</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-orange-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl mb-10 max-w-2xl mx-auto">
            Contact us today to discuss your requirements and get expert assistance
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a 
              href="tel:03135224547"
              className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 text-orange-600 px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-2xl"></i>
              Call Now
            </a>
            <a 
              href="https://wa.me/923135224547" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
